// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2YIjh","col":"CardReaderDesc_col__1BJxw","label":"CardReaderDesc_label__t6sos"};